module.exports = __webpack_public_path__ + "static/media/med2.92aa75e7.jpg";